import { NavLink } from "react-router-dom";
import ArrowRightLight from "../assets/icons/arrow-right-light";
import "../assets/styles/components/check-list-card.scss";
import Trash from "../assets/icons/trash";
import CheckListDelete from "./modal-contents/CheckListDelete";

export default function CheckListCard({
  pv_showed,
  removeCheckList,
  check_list_info,
  context,
}) {
  const handleDelete = () => {
    context.openModal(
      <CheckListDelete
        check_list={check_list_info}
        removeCheckList={removeCheckList}
        context={context}
      />,
      true
    );
  };

  if (check_list_info) {
    return (
      <div className="check-list-card position-relative d-flex align-items-center p-3 overflow-hidden mb-3 mx-md-auto shadow-sm border">
        <NavLink
          to="/check-list-form"
          state={{ pv_info: pv_showed, check_list: check_list_info }}
          className="w-100"
        >
          <strong className="d-block">{check_list_info.checklist.name}</strong>
          <span className="d-block my-2">
            <strong>Versione:</strong> {check_list_info.checklist.version}
          </span>
          <span className="d-block my-2">
            <strong>Ultimo aggiornamento:</strong>{" "}
            {new Date(check_list_info.lastUpdateDate).toLocaleString("it-IT", {
              timeZone: "UTC",
            })}
          </span>
          <span className="d-block my-2">
            <strong>Data creazione:</strong>
            {new Date(check_list_info.creationDate).toLocaleString("it-IT", {
              timeZone: "UTC",
            })}
          </span>
          {check_list_info.isConfirmed ? (
            <span className="d-block my-2">
              <strong>Data completamento:</strong>
              {new Date(check_list_info.lastUpdateDate).toLocaleString(
                "it-IT",
                {
                  timeZone: "UTC",
                }
              )}
            </span>
          ) : null}
          <span className="d-block my-2">
            <strong>RCR:</strong> {check_list_info.nomeRcr}
          </span>
          <span className="d-block my-2">
            <strong>STATO:</strong>{" "}
            {check_list_info.isConfirmed ? (
              <span className="confirmed-label fw-bold">CONFERMATA</span>
            ) : (
              <span className="draft-label fw-bold">BOZZA</span>
            )}
          </span>
        </NavLink>

        {!check_list_info.isConfirmed ? (
          <Trash
            onClick={() => handleDelete()}
            color="#a0a0a0"
            size={22}
            className="position-absolute delete-button"
          />
        ) : null}
        <ArrowRightLight color="#a0a0a0" size={20} className="ms-3" />
      </div>
    );
  }
}
